import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2D6470",
      d: "M6.775 3.225a.347.347 0 0 0-.488 0L5 4.514 3.717 3.225a.347.347 0 0 0-.488 0 .35.35 0 0 0 0 .488l1.284 1.29-1.288 1.284a.343.343 0 0 0 .246.588c.091 0 .179-.033.246-.1L5 5.49l1.283 1.285a.35.35 0 0 0 .492 0 .35.35 0 0 0 0-.488L5.487 5.002l1.284-1.285a.35.35 0 0 0 .004-.492"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "5",
      cy: "5",
      r: "4.5",
      stroke: "#2D6470"
    }, null, -1)
  ]))]))
}
export default { render: render }